import NotificationCard from "./NotificationCard";

export default function PDFNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="pdf"
            destination={"/pdf/" + props.notification.file}
            mediaUrl={props.notification.thumbnail}
            mediaAlt="PDF thumbnail"
            mediaFit="contain"
            showComments
        />
    );
}
